import { memo } from "react";

import type { InputMaybe } from "@/lib/gql/__generated__/graphql";

import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import type { ForNodeType } from "@/components/features/_model/types";
import { QuestionSectionWrapper } from "@/components/features/items/edit/_shared/ui/components/system/question/_layouts/item-wrapper";

import { InputNumberField } from "@/components/ui/form/fields/input-field/input-number";

type Props = {
	maxPeopleNumPerRoom: ForNodeType<InputMaybe<number> | undefined> | undefined;
	onSetMaxPeopleNumPerRoom: (input: number | null | undefined) => void;

	minPeopleNumPerRoom: ForNodeType<number>;
	onSetMinPeopleNumPerRoom: (input: number | null | undefined) => void;

	guide?: string;
	label?: string;
};

export const QuestionMinAndMaxPeopleNumPerRoom = memo(
	({
		maxPeopleNumPerRoom,
		onSetMaxPeopleNumPerRoom,
		minPeopleNumPerRoom,
		onSetMinPeopleNumPerRoom,
		label: _label,
		guide: _guide,
	}: Props) => {
		const handleMinPeopleNum = (e: number | undefined) => {
			const value = e ?? undefined;

			onSetMinPeopleNumPerRoom(value);
		};

		const handleMaxPeopleNum = (e: number | undefined) => {
			const value = e ?? undefined;

			onSetMaxPeopleNumPerRoom(value);
		};

		const isEdited = maxPeopleNumPerRoom?.isEdited ?? minPeopleNumPerRoom?.isEdited ?? false;
		const hasError = Boolean(maxPeopleNumPerRoom?.error || minPeopleNumPerRoom?.error);

		const label = _label || "１部屋につき宿泊可能な人数";
		const guide = _guide || "プランで宿泊する際に、１部屋ごと、宿泊可能な人数を制限することができます。";

		return (
			<FeatureIslandCategoryQuestionForMain
				required={false}
				title={label}
				guide={guide}
				isEdited={isEdited}
				hasError={hasError}
				inputChildren={
					<div className="flex flex-col space-y-6">
						<QuestionSectionWrapper>
							<p>最低</p>
							<InputNumberField
								hiddenSpinButton={false}
								handleInput={handleMinPeopleNum}
								errorMessage={minPeopleNumPerRoom.error}
								value={minPeopleNumPerRoom.value}
							/>
							<p>人から宿泊可能</p>
						</QuestionSectionWrapper>
						<QuestionSectionWrapper>
							<p>最高</p>
							<InputNumberField
								hiddenSpinButton={false}
								handleInput={handleMaxPeopleNum}
								errorMessage={maxPeopleNumPerRoom?.error}
								value={maxPeopleNumPerRoom?.value ?? undefined}
							/>
							<p>人まで宿泊可能</p>
						</QuestionSectionWrapper>
					</div>
				}
			/>
		);
	},
);
